import Vue from 'vue';
import VueNotification from "vue-notification";
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faFileAlt,
    faFileInvoice,
    faClockRotateLeft,
    faChartBar,
    faFileCirclePlus,
    faFileSignature,
    faPaperPlane,
    faCheckSquare,
    faSquare,
    faCalendar,
    faChevronRight,
    faCircleChevronDown,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
    faEllipsisVertical,
    faClock,
    faPiggyBank,
    faCircleExclamation,
    faPen,
    faComment,
    faSpinner,
    faSquareCaretUp,
    faMagnifyingGlass,
    faQuestion,
    faAddressCard,
    faBaby,
    faBars,
    faBriefcase,
    faBuilding,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faCheck,
    faCrown,
    faFile,
    faDownload,
    faFileDownload,
    faHome,
    faIdCardAlt,
    faInfo,
    faInfoCircle,
    faKey,
    faLanguage,
    faList,
    faPenToSquare,
    faPlus,
    faRepeat,
    faRotate,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faTable,
    faTimes,
    faTrash,
    faUser,
    faUserCircle,
    faUserPlus,
    faBell,
    faFlagCheckered,
    faLock,
    faBookmark,
    faEnvelope,
    faCloudArrowUp,
    faCloudArrowDown,
    faX,
    faBan,
    faHourglassHalf,
    faCopy,
    faTriangleExclamation,
    faArrowUpRightFromSquare,
    faExternalLinkAlt,
    faGear,
    faRotateLeft,
    faCircleCheck,
    faFaceFrown,
    faEye,
    faEyeSlash,
    faFileInvoiceDollar,
    faAngleLeft,
    faAngleRight,
    faDollarSign,
    faMinus,
    faAngleDown,
    faAngleUp,
    faFilter,
    faRotateRight,
    faArrowRight,
    faCircleXmark,
    faPlay, faPlayCircle, faChevronDown,
    faFileArrowUp,
    faChevronLeft,
    faGem,
    faTag,
    faArrowRightToBracket,
    faCalendarCheck,
    faCalendarPlus,
    faMapMarkerAlt,
    faCreditCard,
    faLink,
    faTrashAlt,
    faEdit,
    faFingerprint,
    faFileExport,
    faFilePdf,
    faCheckCircle,
    faTimesCircle,
    faExclamationTriangle,
    faHashtag
} from "@fortawesome/free-solid-svg-icons";

import axios from "axios";
import AuthService from "@/services/AuthService";
import { authorization } from '@/services/auth-header';
import VModal from 'vue-js-modal'
import { BootstrapVue, FormDatepickerPlugin, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "@/assets/scss/styles.scss";
import i18n from "./i18n"
import { UtilsVuePlugin } from "@/vue_plugins/UtilsVuePlugin";
import { ConstantsVuePlugin } from "@/vue_plugins/ConstantsVuePlugin";
import VueSignaturePad from "vue-signature-pad";
import Application from "@/state/Application";
import {AUTH_REFRESH_TOKEN_ENDPOINT} from "@/constants/endpoints";
import { faUpload } from "@fortawesome/free-solid-svg-icons/faUpload";
import Auth from "@/state/Auth";
import RouteNames from "@/router/RouteNames";

library.add(faFileAlt, faFileInvoice, faClockRotateLeft, faChartBar, faFileCirclePlus, faFileSignature, faPaperPlane, faCheckSquare, faSquare, faCalendar, faChevronRight, faArrowUp, faArrowDown, faCircleChevronDown, faArrowLeft, faUpload, faAngleRight, faAngleLeft, faEllipsisVertical, faClock, faPiggyBank, faCircleExclamation, faPen, faComment, faSquareCaretUp, faMagnifyingGlass, faSpinner,
    faDownload, faQuestion, faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faTimes, faCheck, faPlus, faKey, faLanguage, faInfo, faTable, faBars, faCaretDown,
    faCaretUp, faAddressCard, faBriefcase, faUserCircle, faIdCardAlt, faBaby, faBuilding, faFile, faTrash, faInfoCircle, faFileDownload, faSortUp, faSortDown,
    faSort, faCaretRight, faRepeat, faList, faCrown, faPen, faPenToSquare, faRotate, faBell, faFlagCheckered, faLock, faBookmark, faEnvelope, faCloudArrowUp, faCloudArrowDown,
    faX, faBan, faHourglassHalf, faCopy, faTriangleExclamation, faArrowUpRightFromSquare, faExternalLinkAlt, faGear, faRotateLeft, faCircleCheck, faFaceFrown, faEye, faEyeSlash, faFileInvoiceDollar,
    faDollarSign, faMinus, faAngleDown, faAngleUp, faFilter, faRotateRight, faArrowRight, faCircleXmark, faPlay, faPlayCircle, faChevronDown, faArrowRightToBracket, faFileArrowUp, faChevronLeft, faGem, faTag, faCalendarCheck, faCalendarPlus,
    faMapMarkerAlt, faCreditCard, faLink, faTrashAlt, faEdit, faFingerprint, faFileExport, faFilePdf, faCheckCircle, faTimesCircle, faExclamationTriangle, faHashtag);

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
    validity: true,
    errorBagName: 'VeeValidateErrors',
});

const dictionary = {
    en: {
        messages: {
            is: (fieldName: string, params: any[], data?: any) => {
                if (fieldName === 'confirm password') {
                    return 'The password confirmation does not match'
                }
                return `The ${fieldName} value is not valid`
            }
        }
    }
};
Validator.localize(dictionary);

Validator.extend('checkPassword', {
    getMessage: field => 'Password should have minimum eight characters, at least one uppercase letter (latin or cyrillic), one lowercase letter (latin or cyrillic), one number and one special character',
    validate: value => /^(?=.*[0-9])(?=.*[a-zа-яё])(?=.*[A-ZА-ЯЁ])(?=.*[!@#$%^&+=\-*?\][{}()<>/\\_.,;|'"]).{8,128}$/.test(value),
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueNotification)
Vue.use(VModal, {
    dynamicDefaults: {
        adaptive: true,
        height: "auto",
        scrollable: true
    }
})

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(UtilsVuePlugin)
Vue.use(ConstantsVuePlugin)

Vue.use(FormDatepickerPlugin)

Vue.use(VueSignaturePad)

let timerNetworkError: NodeJS.Timeout | null = null;
let resolveRepeatRequest = true;

axios.interceptors.response.use(response => {
    if (timerNetworkError) {
        clearTimeout(timerNetworkError);
        timerNetworkError = null;
    }
    resolveRepeatRequest = true;
    Application.showText = false;
    return response;
}, async (error) => {
    if ((error.message === 'Network Error' || error.response.status === 502) && resolveRepeatRequest) {
        if (!timerNetworkError) {
            timerNetworkError = setTimeout(() => {
                resolveRepeatRequest = false;
            }, 90000);
            Application.showText = true;
        }
        return axios(error.toJSON().config);
    }

    const { response, config } = error;

    if (!response) {
        return Promise.reject(error);
    }

    if (response.status !== 401) {
        return Promise.reject(error);
    }

    if (config && config.url === AUTH_REFRESH_TOKEN_ENDPOINT) {
        store.dispatch('Auth/signOut');
        router.push('/login');
        return Promise.reject(error);
    }

    if ((config as any)._retry) {
        store.dispatch('Auth/signOut');
        router.push('/login');
        return Promise.reject(error);
    }

    const tokenExpired = (response.data && response.data.message === 'Token expired') || Boolean(response.headers['token-expired']);

    if (!tokenExpired) {
        store.dispatch('Auth/signOut');
        router.push('/login');
        return Promise.reject(error);
    }

    (config as any)._retry = true;

    try {
        const newAccessToken = await AuthService.refreshToken();
        config.headers = config.headers || {};
        config.headers.Authorization = authorization();
        const user = Auth.getUser;
        if (user && !user.hasActualRequiredPoliciesAcceptance) {
            if (router.currentRoute.name !== RouteNames.POLICY_ACCEPTANCE &&
                router.currentRoute.name !== RouteNames.TERMS_OF_SERVICE &&
                router.currentRoute.name !== RouteNames.PRIVACY_POLICY) {

                router.push({
                    name: RouteNames.POLICY_ACCEPTANCE,
                    params: {
                        uiContext: {
                            name: router.currentRoute.name,
                            params: router.currentRoute.params,
                            query: router.currentRoute.query
                        } as any
                    }
                });
                return Promise.reject(new Error("Policy acceptance required"));
            }
        }
        return axios.request(config);
    } catch (refreshError) {
        store.dispatch('Auth/signOut');
        router.push('/login');
        return Promise.reject(refreshError);
    }
})

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
